var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',{attrs:{"type":_vm.type,"format":_vm.format,"editable":false,"placeholder":_vm.placeholder},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }